import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import settings from "../settings";
import { getClientProps } from "../utils";

import flow from "lodash/flow";
import uniqBy from "lodash/uniqBy";
import filter from "lodash/filter";

const { operator, baseApiUrl, vaixClientId } = settings;
const { apiAuthToken } = getClientProps();

export const smartSearchApi = createApi({
  reducerPath: "searchApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseApiUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("authorization", `Bearer ${apiAuthToken}`);
      headers.set("Origin", "");
      vaixClientId && headers.set("x-vaix-client-id", vaixClientId);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSearch: builder.query({
      query: ({ keyword, userId }) => ({
        url: "/api/search",
        params: {
          token: keyword,
          product: "casino",
          operator: operator,
          mode: "recommended",
          user: userId,
          fields: ["game_id", "game_name", "game_image_url"],
          filters: "game_image:neq:null",
        },
      }),
      transformResponse: (response) =>
        flow(
          (games) => filter(games, (g) => g?.game_image_url),
          (filteredGames) => uniqBy(filteredGames, "game_image_url"),
        )(response.data?.games),
    }),
  }),
});
